declare namespace $ {

	export class $shm_hitalama_map_widget_float_table_command extends $mol_button_minor {
	}
	
}

//# sourceMappingURL=command.view.tree.d.ts.map